import { render, staticRenderFns } from "./CompanyNotices.vue?vue&type=template&id=90363058&"
import script from "./CompanyNotices.vue?vue&type=script&lang=js&"
export * from "./CompanyNotices.vue?vue&type=script&lang=js&"
import style0 from "./CompanyNotices.vue?vue&type=style&index=0&id=90363058&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports